import React, { useState } from 'react';
import { X, Loader2, CheckCircle } from 'lucide-react';
import { Button } from './ui/Button';
interface WaitlistModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function WaitlistModal({
  isOpen,
  onClose
}: WaitlistModalProps) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState('');
  if (!isOpen) return null;
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    try {
      const GOOGLE_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbzjxh1RfuSYw04chiQwIV6cjo7lN-9ulD4KZKZb-iVVUhxMsN8OqWjaiOSPzSndOpDB7g/exec';
      // Google Apps Script requires 'no-cors' mode
      // The request will succeed and data will be saved, but we can't read the response
      await fetch(GOOGLE_SCRIPT_URL, {
        method: 'POST',
        mode: 'no-cors',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          name,
          email
        })
      });
      // If we reach here without error, the submission was successful
      setIsSuccess(true);
      setTimeout(() => {
        onClose();
        // Reset form after closing
        setTimeout(() => {
          setIsSuccess(false);
          setName('');
          setEmail('');
        }, 300);
      }, 2000);
    } catch (err) {
      setError('Something went wrong. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };
  return <div className="fixed inset-0 z-[100] flex items-center justify-center px-4" data-id="element-121">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/20 backdrop-blur-sm transition-opacity" onClick={onClose} data-id="element-122" />

      {/* Modal Content */}
      <div className="relative w-full max-w-md bg-white rounded-2xl shadow-2xl p-6 md:p-8 animate-in fade-in zoom-in-95 duration-200 border border-[#E8E6E3]" data-id="element-123">
        <button onClick={onClose} className="absolute top-4 right-4 p-2 text-gray-400 hover:text-gray-600 transition-colors rounded-full hover:bg-gray-100" data-id="element-124">
          <X className="w-5 h-5" data-id="element-125" />
        </button>

        {isSuccess ? <div className="flex flex-col items-center justify-center py-8 text-center space-y-4" data-id="element-126">
            <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center text-gray-900 mb-2" data-id="element-127">
              <CheckCircle className="w-8 h-8" data-id="element-128" />
            </div>
            <h3 className="text-2xl font-semibold text-gray-900" data-id="element-129">
              You're on the list!
            </h3>
            <p className="text-gray-500" data-id="element-130">
              Thanks for joining. We'll be in touch soon.
            </p>
          </div> : <>
            <div className="mb-8 text-center" data-id="element-131">
              <h3 className="text-2xl font-semibold text-gray-900 mb-2" data-id="element-132">
                Join the Waitlist
              </h3>
              <p className="text-gray-500" data-id="element-133">
                Be the first to know when we launch.
              </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4" data-id="element-134">
              <div className="space-y-2" data-id="element-135">
                <label htmlFor="name" className="text-sm font-medium text-gray-700" data-id="element-136">
                  Full Name
                </label>
                <input id="name" type="text" required value={name} onChange={e => setName(e.target.value)} className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-gray-900 focus:ring-1 focus:ring-gray-900 outline-none transition-all bg-gray-50 focus:bg-white" placeholder="Jane Doe" data-id="element-137" />
              </div>

              <div className="space-y-2" data-id="element-138">
                <label htmlFor="email" className="text-sm font-medium text-gray-700" data-id="element-139">
                  Email Address
                </label>
                <input id="email" type="email" required value={email} onChange={e => setEmail(e.target.value)} className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-gray-900 focus:ring-1 focus:ring-gray-900 outline-none transition-all bg-gray-50 focus:bg-white" placeholder="jane@company.com" data-id="element-140" />
              </div>

              {error && <p className="text-red-500 text-sm text-center" data-id="element-141">{error}</p>}

              <Button type="submit" variant="primary" className="w-full py-3 mt-2" disabled={isLoading} data-id="element-142">
                {isLoading ? <span className="flex items-center gap-2" data-id="element-143">
                    <Loader2 className="w-4 h-4 animate-spin" data-id="element-144" />
                    Joining...
                  </span> : 'Join Waitlist'}
              </Button>
            </form>
          </>}
      </div>
    </div>;
}